import { useQuery } from '@tanstack/react-query';
import { DriveRequests } from 'src/requests/drive';
import { QueryKey, queryRetry } from 'src/utils/react-query';

export const useDriveInfoQuery = () => {
  const queryKey = [QueryKey.DRIVE, 'info'];
  const { data: driveInfo, isLoading } = useQuery(
    queryKey,
    () => DriveRequests.getDriveInfo(),
    {
      keepPreviousData: true,
      retry: queryRetry,
    },
  );
  return {
    driveInfo,
    isDriveInfoLoading: isLoading,
  };
};
